<template>
    <div id="kanban">

        <div id="header" class="fw-bolder" style="background-color: #fff; padding: 10px 20px;">
            <span :class="cor.texto" style="font-size: 16px">
                {{ titulo }}
            </span>
        </div>

        <BCard class="card-lista-documentos mb-0" id="card">
            <draggable class="list-group" tag="ul" v-model="lista" v-bind="dragOptions">
                <transition-group>
                    <li class="list-group-item flex justify-content-center mb-2 lista-documentos" :class="[cor.borda, showCursor ? 'cursor-pointer' : '']" v-for="documento in lista" :key="documento.sq_upload" @click="$emit('clickKanban', documento)">
                        <h6 class="fw-bolder">
                            <i class="bx bx-user fw-bolder"></i>
                            {{documento.cooperado}}
                        </h6>
                        <h6 class="fw-light">
                            <i class="bx bx-folder"></i>
                            {{documento.ds_upload}}
                        </h6>
                        <h6 class="fw-light">
                            <i class="bx bx-envelope"></i>
                            {{documento.email}}
                        </h6>
                        <h6 class="m-0 fw-light">
                            <i class="bx bx-calendar-alt"></i>
                            {{documento.data_aceite}}
                        </h6>
                    </li>
                </transition-group>
            </draggable>
        </BCard>
        
        <div id="footer" class="fw-bolder" style="background-color: #fff; padding: 10px 20px;">
            <span>Total: {{ qtdRegistros }}</span>
        </div>

    </div>
</template>

<script>
    import draggable from 'vuedraggable'

    export default({
        props: {
            titulo      : String,
            classeCor   : String,
            desabilitado: Boolean,
            showCursor  : Boolean,
            listaKanban : Array
        },
        components: {
            draggable,
        },
        data() {
            return {
                lista: this.listaKanban,
                cor  : {
                    texto: "text-" + this.classeCor,
                    borda: "border-" + this.classeCor,
                },
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation : 150,
                    group     : "cooperado",
                    disabled  : this.desabilitado,
                    ghostClass: "ghost"
                };
            },
            qtdRegistros() { return this.lista.length },
        }
    });

</script>

<style>
    .lista-documentos{
        border-top-width   : 1px!important;
        border-top-color   : #eff2f7!important;
        border-right-color : #eff2f7!important;
        border-bottom-color: #eff2f7!important;
        border-left-width  : 5px;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    #kanban{
        height: calc(100% - 25px);
    }

    .card-lista-documentos{
        height    : 100%;
        overflow  : auto;
        overflow-x: hidden;
    }

    #card > .card-body{
        padding-top   : 0;
        padding-bottom: 0;
    }
</style>